import { connect } from 'react-redux';
import { selectTaps } from "../../../../store/slices/search/selectors";
import { ActionSearch } from "../../../../store/slices/search/actions";
import { Input } from "./Input";
var mapStateToProps = function mapStateToProps(state) {
  var _selectTaps;
  return {
    withIndent: !((_selectTaps = selectTaps(state)) !== null && _selectTaps !== void 0 && _selectTaps.length)
  };
};
var mapDispatchToProps = {
  onSearch: function onSearch(query) {
    return ActionSearch.fetchSearchData({
      query: query
    });
  },
  onChange: ActionSearch.setQuery
};
export var SearchInput = connect(mapStateToProps, mapDispatchToProps)(Input);